import React, { FC, forwardRef, RefObject } from 'react';
import styled, { css } from 'styled-components';
import { BaseFormProps } from './Base';
import { FormFieldInline, FormFieldInlineProps } from './FormFieldInline';

const StyledCheckboxWrapper = styled.div`
  ${({ theme: { space, colors, borders, global } }) => css`
    label {
      align-items: flex-start;
      position: relative;

      &:before {
        content: '';
        width: 24px;
        height: 24px;
        border: ${borders.default};
        background: ${colors.white.default};
        transition: all 0.2s ease;
        border-radius: ${global.borderRadius.default};
        flex-shrink: 0;
      }

      &:after {
        content: '';
        width: 16px;
        height: 13px;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 13'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0-1h16v16H0z'/%3E%3Cpath fill='%23FFF' d='M.234 7.336a.8.8 0 0 1 0-1.132l1.132-1.131a.8.8 0 0 1 1.131 0L6 8.576l7.503-7.503a.8.8 0 0 1 1.131 0l1.132 1.131a.8.8 0 0 1 0 1.132l-9.2 9.2a.8.8 0 0 1-1.132 0l-5.2-5.2Z'/%3E%3C/g%3E%3C/svg%3E");
        position: absolute;
        top: 5px;
        left: 4px;
        opacity: 0;
        transform: scale(0);
        transition: all 0.2s ease;
      }

      &:hover {
        cursor: pointer;
        &:before {
          border-color: ${colors.black.default};
        }
      }
    }

    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;

      &:checked + label {
        &:before {
          background: ${colors.brand.default};
        }

        &:after {
          opacity: 1;
          -webkit-transform: scale(1);
          transform: scale(1);
        }

        &:hover {
          border-color: ${colors.brand.default};
        }
      }
    }
  `};
`;

export interface CheckboxProps extends BaseFormProps, FormFieldInlineProps {
  checked?: boolean;
  onChange?: any;
  value?: string;
}

export const Checkbox: FC<CheckboxProps> = forwardRef(
  (
    {
      label,
      id,
      tooltipText,
      tooltipInfoIcon,
      valid,
      invalid,
      constrained,
      required,
      checked,
      disabled,
      value,
      onChange,
      ...rest
    },
    ref
  ) => (
    <StyledCheckboxWrapper>
      <FormFieldInline
        label={label}
        htmlFor={id}
        tooltipText={tooltipText}
        tooltipInfoIcon={tooltipInfoIcon}
        required={required}
        {...rest}
      >
        <input
          type="checkbox"
          id={id}
          name={id}
          checked={checked}
          disabled={disabled}
          value={value}
          ref={ref as RefObject<HTMLInputElement>}
          onChange={onChange}
        />
      </FormFieldInline>
    </StyledCheckboxWrapper>
  )
);
